// src/padplanner/ppMapStyle.js
//
// The dark basemap for the dashboard's pins card (mockup 1): Mapbox dark-v11
// through the Static Tiles API, as a MapLibre raster source. Raster rather
// than the vector style because the vector style needs Mapbox GL's sprite and
// glyph conventions; useBasemapStore.basemapTileUrl serves its Mapbox styles
// the same way.
//
// The token is the runtime one (/config.json mapboxToken, UI_MAPBOX_TOKEN),
// never a build-time value. Mapbox's terms require the attribution to be
// shown with working links, including "Improve this map", so the map that
// uses this style shows the attribution control expanded; lib/map/attribution.js
// has the credits, points that link at the camera and has the logo.
//
// The dark style is the pins card's alone. Every other PadPlanner map has the
// user's pick from useBasemapStore (padplannerBasemapId, satellite-streets-v12
// by default) through ppBasemapStyle, as a raster at the bottom of the stack.
// There is no fallback: a missing token is a broken deploy, and a different
// basemap would hide that.
import { getConfig } from "../config";
import { basemapTileUrl } from "../stores/useBasemapStore";
import { MAPBOX_ATTRIBUTION, basemapAttribution } from "../lib/map/attribution";

export { MAPBOX_ATTRIBUTION, basemapAttribution };

/** The pins card's style id, for the Improve link. */
export const DARK_STYLE_ID = "dark-v11";

export function darkTileUrl(token) {
  return `https://api.mapbox.com/styles/v1/mapbox/${DARK_STYLE_ID}/tiles/512/{z}/{x}/{y}@2x?access_token=${encodeURIComponent(token)}`;
}

/** A MapLibre style: one raster layer of Mapbox dark-v11. */
export function ppDarkStyle(token = getConfig().mapboxToken) {
  return {
    version: 8,
    sources: {
      "pp-dark": { type: "raster", tiles: [darkTileUrl(token)], tileSize: 512, maxzoom: 22, attribution: MAPBOX_ATTRIBUTION },
    },
    layers: [{ id: "pp-dark", type: "raster", source: "pp-dark" }],
  };
}

export const BASE_ID = "pp-base";

/** The raster source for a picked Mapbox style: 512 px Static Tiles, credited. */
export function basemapSource(styleId) {
  return { type: "raster", tiles: [basemapTileUrl(styleId, 512)], tileSize: 512, maxzoom: 22, attribution: basemapAttribution(styleId) };
}

/** A MapLibre style: one raster layer of the picked Mapbox style. */
export function ppBasemapStyle(styleId) {
  return {
    version: 8,
    sources: { [BASE_ID]: basemapSource(styleId) },
    layers: [{ id: BASE_ID, type: "raster", source: BASE_ID }],
  };
}
